<template>
  <transition name="fade">
    <div class="onboarding-circuit-mode-section">
      <span
        class="onboarding-circuit-mode-section__mask onboarding-circuit-mode-section__mask--top"
      />
      <span
        class="onboarding-circuit-mode-section__mask onboarding-circuit-mode-section__mask--bottom"
      />
      <span
        class="onboarding-circuit-mode-section__mask onboarding-circuit-mode-section__mask--left"
      />
      <span
        class="onboarding-circuit-mode-section__mask onboarding-circuit-mode-section__mask--right"
      />

      <svg
        class="onboarding-circuit-mode-section__corner onboarding-circuit-mode-section__corner--left-top"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 0H0V10C0 4.47715 4.47715 0 10 0Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>

      <svg
        class="onboarding-circuit-mode-section__corner onboarding-circuit-mode-section__corner--right-top"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10 10L10 0L0 -4.37114e-07C5.52285 -1.95703e-07 10 4.47715 10 10Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>

      <svg
        class="onboarding-circuit-mode-section__corner onboarding-circuit-mode-section__corner--left-bottom"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.31134e-06 0L0 10L10 10C4.47715 10 5.87108e-07 5.52285 1.31134e-06 0Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>

      <svg
        class="onboarding-circuit-mode-section__corner onboarding-circuit-mode-section__corner--right-bottom"
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0 10L10 10L10 0C10 5.52285 5.52285 10 0 10Z"
          fill="black"
          fill-opacity="0.6"
        />
      </svg>

      <section class="onboarding-circuit-mode-section__modal">
        <svg
          class="onboarding-circuit-mode-section__bottom-arrow"
          width="20"
          height="10"
          viewBox="0 0 20 10"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10 10L8.74228e-07 -1.74846e-06L20 0L10 10Z" fill="white" fill-opacity="0.9" />
        </svg>

        <header class="onboarding-circuit-mode-section__header">
          <p class="onboarding-circuit-mode-section__tag" v-text="$tc('common.new')" />
          <h3
            class="onboarding-circuit-mode-section__title"
            v-text="$tc('HomePage.countdown.circuitMode.onboarding.title')"
          />
        </header>
        <p
          class="onboarding-circuit-mode-section__description"
          v-html="$tc('HomePage.countdown.circuitMode.onboarding.description')"
        />
        <button
          class="onboarding-circuit-mode-section__button onboarding-circuit-mode-section__button--light--secondary"
          v-text="$tc('common.ok')"
          @click="emitClose"
        />
      </section>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'

/**
 * HOME サーキットモード用 オンボーディングセクション
 */
export default defineComponent({
  name: 'OnboardingCircuitModeSection',
  mounted() {
    /**
     * マスク(下)の高さを設定する
     */
    this.setBottomMaskHeight()
  },
  methods: {
    /**
     * クローズイベントをemitする
     */
    emitClose() {
      this.$emit('close')
    },
    /**
     * マスク(下)の高さを設定する
     */
    setBottomMaskHeight() {
      const homePane = document.querySelector('.home-pane') as HTMLElement
      const bottomMask = document.querySelector(
        '.onboarding-circuit-mode-section__mask--bottom',
      ) as HTMLElement
      const snsList = document.querySelector('.home-pane .home-pane__sns-list') as HTMLElement

      const { scrollTop } = homePane
      const { height, top } = snsList.getBoundingClientRect()
      const maskTop = bottomMask.getBoundingClientRect().top + scrollTop

      // マスクの高さを設定
      bottomMask.style.height = `${height + top + scrollTop - maskTop}px`
    },
  },
})
</script>

<style lang="scss" scoped>
.onboarding-circuit-mode-section {
  transition: opacity ease 0.3s;

  &.fade-enter-active,
  &.fade-leave-active {
    opacity: 1;
    pointer-events: auto;
  }

  &.fade-enter,
  &.fade-leave-to {
    opacity: 0;
    pointer-events: none;
  }

  &__mask {
    position: absolute;
    background: rgba(#000, 0.6);
    z-index: 5;

    &--top {
      bottom: calc(100% + 10px);
      right: 50%;
      width: 100vw;
      height: max(100vh, 900px);
      transform: translate(50%, 0);
    }

    &--bottom {
      top: calc(100% + 10px);
      right: 50%;
      width: 100vw;
      min-height: 100vh;
      transform: translate(50%, 0);
    }

    &--left {
      top: -10px;
      bottom: -10px;
      right: calc(100% + 20px);
      width: calc(50vw - 50% - 20px);
    }

    &--right {
      top: -10px;
      bottom: -10px;
      left: calc(100% + 20px);
      width: calc(50vw - 50% - 20px);
    }
  }

  &__corner {
    position: absolute;
    z-index: 5;
    width: 10px;
    height: 10px;

    &--left-top {
      top: -10px;
      left: -20px;
    }

    &--right-top {
      top: -10px;
      right: -20px;
    }

    &--left-bottom {
      bottom: -10px;
      left: -20px;
    }

    &--right-bottom {
      bottom: -10px;
      right: -20px;
    }
  }

  &__modal {
    position: absolute;
    left: 50%;
    bottom: calc(100% + 34px);
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: center;
    gap: 20px;
    width: min(calc(100vw - 32px), 450px);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.9);
    backdrop-filter: blur(2.5px);
    transform: translate(-50%, 0);
    z-index: 6;
  }

  &__bottom-arrow {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  &__title {
    color: $black;
    text-align: center;
    font-family: $fontSignup;
    font-size: 16px;
    font-weight: 500;
    line-height: 1.5;
    letter-spacing: 0.04em;
  }

  &__tag {
    display: inline-flex;
    padding: 4px 11px;
    align-items: center;
    gap: 10px;
    background: $green-light;
    color: $black;
    text-align: center;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.33;
    letter-spacing: 0.04em;
    border-radius: 40px;
  }

  &__description {
    color: $gray75;
    font-size: 12px;
    line-height: 1.66;
  }

  &__button {
    @include button();

    height: 40px;
    width: 100%;
  }
}
</style>
